import React from 'react';
import { Link } from 'react-router-dom';

const FooterLogo = () => (
  <div className="flex items-center">
    <div className="rounded-2xl bg-white p-2">
      <img
        src="/uptown-logo.svg"
        alt="Uptown Physiotherapy Clinic"
        className="h-14 w-14 object-contain"
      />
    </div>
  </div>
);

const Column = ({ title, items }) => (
  <div>
    <div className="text-[11px] font-semibold tracking-[0.15em] text-neutral-400 uppercase">{title}</div>
    <ul className="mt-5 space-y-3 text-[14px] text-neutral-200">
      {items.map((i) => (
        <li key={i.label}>
          <Link to={i.to} className="hover:text-white transition-colors link-underline">{i.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  return (
    <footer id="footer" className="px-6 pb-6">
      <div className="max-w-[1240px] mx-auto rounded-[28px] bg-neutral-950 text-white overflow-hidden">
        <div className="px-8 lg:px-14 pt-14 pb-10">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <FooterLogo />
            <div className="text-[14px] leading-relaxed text-neutral-300 lg:text-right">
              <p>Uptown Physiotherapy Clinic</p>
              <p>960 Tecumseh Rd E, Windsor, ON N8X 2S6</p>
              <a href="tel:+15192522752" className="hover:text-white transition-colors">+1-519-252-2752</a>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/team" className="inline-flex items-center gap-2 bg-[#CA0028] hover:bg-[#A80021] text-white text-[13px] font-medium px-5 py-2.5 rounded-full transition-colors">
                Meet the Team
              </Link>
              <a href="tel:+15192522752" className="inline-flex items-center gap-2 bg-white text-neutral-900 hover:bg-neutral-200 text-[13px] font-medium px-5 py-2.5 rounded-full transition-colors">
                Call to Book
              </a>
            </div>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
            <Column title="SERVICES" items={[
              { label: 'Physiotherapy', to: '/services/physiotherapy' },
              { label: 'Athletic Therapy', to: '/services/athletic-therapy' },
              { label: 'Massage Therapy', to: '/services/massage-therapy' },
              { label: 'Acupuncture', to: '/services/acupuncture-dry-needling' },
              { label: 'Occupational Therapy', to: '/services/occupational-therapy' },
              { label: 'Manual Therapy', to: '/services/manual-therapy' },
            ]} />
            <Column title="CONDITIONS" items={[
              { label: 'Post-Surgical Rehab', to: '/services/post-surgical-rehab' },
              { label: 'Pelvic Health', to: '/services/pelvic-health' },
              { label: 'Vestibular Rehab', to: '/services/vestibular-rehab' },
              { label: 'Concussion', to: '/services/concussion-rehab' },
              { label: 'Chronic Pain', to: '/services/chronic-pain' },
            ]} />
            <Column title="CLINIC" items={[
              { label: 'About Us', to: '/about' },
              { label: 'Our Team', to: '/team' },
              { label: 'All Locations', to: '/locations' },
              { label: 'News & Press', to: '/news' },
            ]} />
            <Column title="PATIENTS" items={[
              { label: 'Appointment Request', to: '/appointment' },
              { label: 'Free Injury Screen', to: '/contact' },
              { label: 'Ergonomics', to: '/services/ergonomics' },
              { label: 'Sports Training', to: '/services/sports-specific-training' },
            ]} />
            <Column title="LEGAL" items={[
              { label: 'Terms & Conditions', to: '/terms' },
              { label: 'Privacy Policy', to: '/privacy-policy' },
              { label: 'Legal Notice', to: '/legal-notice' },
            ]} />
          </div>
        </div>

        <div className="border-t border-white/10 px-8 lg:px-14 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-neutral-400">
            &copy; 2025 Uptown Physiotherapy Clinic. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
